module.exports = __webpack_public_path__ + "img/new-footer-logo.7f87e205.svg";